import React from 'react';

/**
 * Centralized logo configuration. Update these to change the logo app-wide.
 */
export const LOGO_TEXT = 'Twilanswer';
export const LOGO_ICON_SRC = '/TwilanswerIconSVG.svg';

const SIZE_CLASSES = {
  sm: { icon: 'h-8 w-8', text: 'text-lg' },
  md: { icon: 'h-10 w-10', text: 'text-xl' },
  lg: { icon: 'h-12 w-12', text: 'text-2xl' },
};

/**
 * Logo component: icon (SVG) + "Twilanswer" text in Roboto Bold.
 * Use this everywhere instead of embedding logo images so branding stays consistent.
 *
 * @param {string} [size='md'] - 'sm' | 'md' | 'lg' for icon and text scale
 * @param {string} [className] - Additional classes for the wrapper (e.g. for alignment/width)
 * @param {boolean} [showText=true] - If false, only the icon is shown
 */
function Logo({ size = 'md', className = '', showText = true }) {
  const { icon: iconClass, text: textClass } = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      className={`inline-flex items-center gap-1 ${className}`}
      style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 700 }}
    >
      <img
        src={LOGO_ICON_SRC}
        alt=""
        className={`${iconClass} flex-shrink-0 object-contain`}
        aria-hidden
      />
      {showText && (
        <span className={`${textClass} text-black flex-shrink-0`}>
          {LOGO_TEXT}
        </span>
      )}
    </div>
  );
}

export default Logo;
